// removed by extract-text-webpack-plugin
module.exports = {"content":"contacts__content-18v46 blocks__content--MOaB","listItem":"contacts__listItem-1jaEO","phoneText":"contacts__phoneText-2KlAN","phone":"contacts__phone-IDTq9","mail":"contacts__mail-2nM5G","address":"contacts__address-3csXK","addressText":"contacts__addressText-24dsS","listTitle":"contacts__listTitle-2kD6Q","phoneNumber":"contacts__phoneNumber-3-zrU","map":"contacts__map-2GGjW","text":"contacts__text-2zEq4"};


//////////////////
// WEBPACK FOOTER
// ./components/contacts/contacts.css
// module id = 832
// module chunks = 0